
import './ProfileItem.scss';
export default function ProfileItem(props: { onClick: () => void, profileName: string, profileImage: string }) {
    return (
        <div className="profile-avatar-appear-done profile-avatar-enter-done " onTouchStart={() => {
            props.onClick();
        }} onClick={() => {
            props.onClick();
        }} style={{ textAlign: 'center' }}>
            <div aria-label={props.profileName} data-testid="profile-avatar-0" role="button"
                tabIndex={0} data-gv2elementkey="profileId"
                data-gv2elementvalue="1abd810a-7e7b-4685-8c62-f6dfbfdb6793" data-gv2interactionkey="profileId"
                data-index={0} className="sc-kLIISr sc-iGPElx jZNVMe" data-gv2-interaction-bound="true">
                <div className="sc-dliRfk sc-jXQZqI epxcRE profile-avatar" style={{
                    background: `url('${props.profileImage}')  0% 0%/contain no-repeat`
                }}>
                </div>
                <h3 className="margin--top-6 text--center text-color--primary">{props.profileName}</h3>
            </div>
        </div>
    );
}